const localStorage = window.localStorage
export default {
  getItem(key) {
    const result = JSON.parse(localStorage.getItem(key))
    return result
  },
  setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  removeItem(key) {
    localStorage.removeItem(key)
  }
}
